// extracted by mini-css-extract-plugin
module.exports = {"CustomCheckboxDiv":"styles_CustomCheckboxDiv__i8xR3","CustomCheckboxDivSelected":"styles_CustomCheckboxDivSelected__2SUvR","Disabled":"styles_Disabled__1GOjV"};